import React from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';

exports.EditRegCountDialog = props => {
    let actions = [
        <RaisedButton
          label="Save"
          style={{ padding: '2%' }}
          primary={true}
          onClick={props.editRegCount_save}
          data-e2e="regPlayerCountSave"
        />,
        <RaisedButton
            label="Cancel"
            style={{ padding: '2%' }}
            primary={true}
            onClick={props.editRegCount_close}
            data-e2e="regPlayerCountCancel"
        />
    ];
    return (
        <div>
            {props.open ?
                <Dialog
                    contentStyle={{ width: '70%' }}
                    title={'Edit'}
                    actions={actions}
                    modal={false}
                    open={props.open}
                    onRequestClose={props.editRegCount_close}
                >
                    <div>
                    <input
                        type="text"
                        value={props.editTournamentData.RegPlayersCount}
                        onChange={props.editRegCount_change}
                        className="form-control"
                        style={{ marginTop: '2%', marginBottom: '2%' }}
                        data-e2e="regPlayerCountTxtBox"
                    />
                    <span style={{ color: 'red' }} >
                        {props.editTournamentData.RegPlayersCount_error}
                    </span>
                    </div>
                </Dialog> : 
                null
            }
        </div>
    )
}




/** WEBPACK FOOTER **
 ** ./src/components/TournamentWatch/EditRegCountDialog.js
 **/